
export default function NotFound() {
  return (
    <main className="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center p-8">
      <div className="max-w-2xl w-full text-center">
        <h1 className="text-5xl font-bold mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">Page non trouvée</h2>
        <p className="text-gray-400 mb-6">Oups ! La page que vous cherchez n'existe pas ou a été déplacée.</p>
        <a href="/" className="text-primary-400 hover:underline">Retour à l'accueil</a>
      </div>
    </main>
  );
}
